import axios from '../utils/axios';
import camelcaseKeys from 'camelcase-keys-recursive';

const GET_EVENTS_REQUEST = 'GET_EVENTS_REQUEST';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE';

export const getEvents = () => {
  return dispatch => {
    dispatch({ type: GET_EVENTS_REQUEST });
    
    return axios.get('api/events', {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    })
      .then(response => {
        const events = camelcaseKeys(response.data).events;
        dispatch(getEventsSuccess(events));
      })
      .catch(error => getEventsFailure(error));
  }
};

const getEventsSuccess = (events) => {
  return {
    type: GET_EVENTS_SUCCESS,
    events,
  }
};

const getEventsFailure = (error) => {
  return {
    type: GET_EVENTS_FAILURE,
    error,
  }
};
